import { Component, OnInit, ViewChild } from '@angular/core';
import {
  MatPaginator, MatTableDataSource,
  MAT_DIALOG_DATA,
  MatSort
} from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { MatDialog, MatDialogRef, } from '@angular/material/dialog';
import { EdituserComponent } from '../edituser/edituser.component';
import { UsersService } from '../../../services/users/users.service';
import { DataSource } from '@angular/cdk/collections';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { ExcelgeneratorService } from '../../../services/excelgenerator/excelgenerator.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-alluserrole',
  templateUrl: './alluserrole.component.html',
  styleUrls: ['./alluserrole.component.scss']
})
export class AlluserroleComponent implements OnInit {
  showFiller = false;

  columnsToDisplay = [
    'username',
    'name',
    'resourceType',
    'branchNames',
    'userRole',
    'userSince',
    'userActive',
    'actions'
  ];
  usersDataArray = new MatTableDataSource;
  excelRecords = [];
  isLoading: boolean = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    public dialog: MatDialog,
    public userService: UsersService,
    public snackBar: MatSnackBar,
    private router: Router,
    public excelService: ExcelgeneratorService,
    public datePipe: DatePipe
  ) {

  }

  ngOnInit() {
    this.isLoading = true;
    this.userService.getAllUsers().subscribe(res => {
      console.log("All Users", res)
      this.isLoading = false;
      this.usersDataArray.data = res;

      this.usersDataArray.paginator = this.paginator;
    }, Error => {
      this.isLoading = false;
      console.log(Error);
    });

    this.usersDataArray.sortingDataAccessor = (item: any, property) => {
      switch (property) {
        case 'username': return item.username;
        case 'name': return item.resource.firstName;
      }
    };
    this.usersDataArray.sort = this.sort;
  }

  onChange(Event, userid) {
    console.log(Event.checked, userid);
    if (Event.checked) {
      this.userService.activateUser(userid, true).subscribe(res => {
        console.log(res);
      }, Error => {
        console.log(Error);
      });
    } else {
      this.userService.activateUser(userid, false).subscribe(res => {
        console.log(res);
      }, Error => {
        console.log(Error);
      });
    }
  }

  editUser(id) {
    let editDialog = this.dialog.open(EdituserComponent, {
      width: '800px',
      data: {
        user: id
      }
    });
    editDialog.updatePosition({
      top: '50px', right: '0px',
    });
    editDialog.afterClosed().subscribe(result => {
      if (result) {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
          this.router.navigate(["/userandrole"]));
      }
    });
  }

  applyFilter(filterValue: string) {
    this.usersDataArray.filter = filterValue.trim().toLowerCase();
    this.usersDataArray.filterPredicate = (data: any, filter: string) => {
      let isFirstName = false, isLastName = false, isUsername = false;
      if (data) {
        if (data.resource) {
          if (data.resource.firstName) {
            isFirstName = data.resource.firstName.toString().toLowerCase().indexOf(filter) != -1;
          }
          if (data.resource.lastName) {
            isLastName = (data.resource.firstName + " " + data.resource.lastName).toString().toLowerCase().indexOf(filter) != -1 || data.resource.lastName.toString().toLowerCase().indexOf(filter) != -1;
          }
        }
        if (data.username) {
          isUsername = data.username.toString().toLowerCase().indexOf(filter) != -1;
        }
      }
      return isFirstName || isLastName || isUsername;
    };
  }

  exportAsXLSX() {
    let usersData = [];
    console.log(usersData)
    usersData = this.usersDataArray.data;
    this.excelRecords = [];
    usersData.forEach(user => {
      let roles = '', branches = '';
      user.roles.forEach(role => {
        roles += role.roleName + " \n"
      });
      user.branchesMapped.forEach(branch => {
        if(branch.area){
          branches += branch.branchName + ' - ' + branch.area + " \n"
        }
        else{
          branches +=  branch.branchName || '' + " \n"

        }
      });
      if (user) {
        this.excelRecords.push({
          'User Name' : user.username || '',
          'Name' : user.resource.firstName || '' + user.resource.lstName || '',
          'Phone No' : user.resource.phoneNumber1 || '',
          'Resource Type' : user.resource.resourceType || '',
          'Branch Names' : branches,
          'User Role' : roles,
          'User Since' :this.datePipe.transform(user.registrationDateTime , "mediumDate") || '',
        })
      }

    });
    this.excelService.exportAsExcelFile(this.excelRecords, 'users');
  }
}

export interface UsertListElement {
  userName: string,
  firstname: string,
  lastname: string,
  userRole: string,
  email: string,
  registrationDate: string,
  userActive: string,
  actions: any
}